import { render } from "./ServiceReport.vue?vue&type=template&id=1b7b39ca&scoped=true"
import script from "./ServiceReport.vue?vue&type=script&lang=js"
export * from "./ServiceReport.vue?vue&type=script&lang=js"

import "./ServiceReport.vue?vue&type=style&index=0&id=1b7b39ca&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7b39ca"]])

export default __exports__